module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_kueche_01.f50e12ac.jpg";